import React, {useState, useEffect} from 'react'
import { withComponentLabel } from '../../utils/debug'

const NewListContent = ({items, home, currentList, clickHandler}) => {
  return (
    <div className='flex flex-col p-4 gap-4 border-t-2 w-full items-stretch'>
      {items.map((item, i) => (
        <NewListItem
          key={i}
          item={item}
          clickHandler={clickHandler}
          checked={currentList.items.includes(item)}
        />
      ))}
    </div>
  )
}

const NewListItem = ({item, i, clickHandler, checked}) => {
  const [isChecked, setisChecked] = useState(checked)

  useEffect(() => {
    setisChecked(checked)
  }, [checked])

  const onClick = () => {
    setisChecked(!isChecked)
    clickHandler(item)
  }

  return (
    <div
      className={`${
        isChecked ? 'bg-orange-400 text-white' : 'bg-orange-50 text-slate-600'
      } transition ease-in-out duration-300 rounded-full border-2 border-orange-300 p-5`}
    >
      <div
        key={i}
        name={item.name}
        checked={isChecked}
        onClick={() => onClick()}
        className='text-center tracking-wider  text-xl'
      >
        {item.name}
      </div>
    </div>
  )
}

export default withComponentLabel(NewListContent, 'NewListContent')
